import { StrictMode } from 'react';

import ReactDOM from 'react-dom/client';

import EntryPoint from './entry-point';

import '@/_shared/css/style.css';

/**
 * Starting point of the app
 * It connects Js to HTML
 * include all global styling here.
 * Strict mode works only in dev environment and helps in finding bugs.
 */

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <EntryPoint />
  </StrictMode>
);
